import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Alert,
  Snackbar,
} from '@mui/material';
import { getSettings, updateSettings } from '../app/api';
import { useTranslation } from '../app/LanguageContext';

const SettingsPage = () => {
  const { translate } = useTranslation();
  const [formData, setFormData] = useState({
    order_default_validity_days: 0,
  });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const res = await getSettings();
      if (res.data) {
        setFormData({
          order_default_validity_days: res.data.order_default_validity_days || 0,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateSettings({
        order_default_validity_days: parseInt(formData.order_default_validity_days, 10) || 0,
      });
      setSnackbar({ open: true, message: translate('settings.saved'), severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {translate('settings.title')}
      </Typography>

      <Paper elevation={3} sx={{ p: 3, mt: 2, maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            type="number"
            label={translate('settings.order_default_validity_days')}
            helperText={translate('settings.order_default_validity_days_help')}
            value={formData.order_default_validity_days}
            onChange={(e) => setFormData((f) => ({ ...f, order_default_validity_days: e.target.value }))}
            inputProps={{ min: 0 }}
          />
          <Box sx={{ mt: 3 }}>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? translate('common.loading') : translate('common.save')}
            </Button>
          </Box>
        </Box>
      </Paper>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert onClose={() => setSnackbar((s) => ({ ...s, open: false }))} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SettingsPage;

